import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';

import Layout from './components/Layout';

// pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Patients from './pages/Patients';
import AddPatient from './pages/AddPatient';
import RecordForm from './pages/RecordForm';
import PatientDetail from './pages/PatientDetail';
import HealthRecords from './pages/HealthRecords';
import PatientVolunteerAssign from './pages/PatientVolunteerAssign';

// Volunteers Module
import VolunteerList from './pages/Volunteers/VolunteerList';

// Economic Module Pages
import EconomicDashboard from './pages/Economic/Dashboard';
import VulnerableList from './pages/Economic/VulnerableList';
import AssistancePriority from './pages/Economic/AssistancePriority';
import WelfareRecipients from './pages/Economic/WelfareRecipients';

// Events
import EventList from './pages/Events/EventList';
import EventCreate from './pages/Events/EventCreate';
import EventDetail from './pages/Events/EventDetail';

// auth
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './routes/ProtectedRoute';
import Unauthorized from './pages/Unauthorized';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>

            {/* ================= LOGIN ================= */}
            <Route path="/login" element={<Login />} />
            <Route path="/unauthorized" element={<Unauthorized />} />

            {/* ================= APP (ต้อง login) ================= */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              {/* Dashboard */}
              <Route index element={<Dashboard />} />

              {/* Health Records */}
              <Route
                path="health-records/new"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER', 'VOLUNTEER']}>
                    <RecordForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="health-records/edit/:recordId"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER', 'VOLUNTEER']}>
                    <RecordForm />
                  </ProtectedRoute>
                }
              />

              {/* Patients */}
              <Route
                path="patients"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER', 'VOLUNTEER']}>
                    <Patients />
                  </ProtectedRoute>
                }
              />

              <Route
                path="patients/new"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER']}>
                    <AddPatient />
                  </ProtectedRoute>
                }
              />

              <Route
                path="patients/:id"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER', 'VOLUNTEER']}>
                    <PatientDetail />
                  </ProtectedRoute>
                }
              />

              <Route
                path="patients/:id/health-records"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER', 'VOLUNTEER']}>
                    <HealthRecords />
                  </ProtectedRoute>
                }
              />

              <Route
                path="patients/assign-volunteer"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER']}>
                    <PatientVolunteerAssign />
                  </ProtectedRoute>
                }
              />

              {/* Volunteers Management */}
              <Route
                path="volunteers"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER']}>
                    <VolunteerList />
                  </ProtectedRoute>
                }
              />

              {/* ================= Economic Module ================= */}
              <Route
                path="economic/dashboard"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER']}>
                    <EconomicDashboard />
                  </ProtectedRoute>
                }
              />

              <Route
                path="economic/vulnerable"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER']}>
                    <VulnerableList />
                  </ProtectedRoute>
                }
              />

              <Route
                path="economic/assistance-priority"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER', 'VOLUNTEER']}>
                    <AssistancePriority />
                  </ProtectedRoute>
                }
              />

              <Route
                path="economic/welfare-recipients"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER']}>
                    <WelfareRecipients />
                  </ProtectedRoute>
                }
              />

              {/* ================= Events ================= */}
              <Route
                path="events"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER', 'VOLUNTEER']}>
                    <EventList />
                  </ProtectedRoute>
                }
              />

              <Route
                path="events/new"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER']}>
                    <EventCreate />
                  </ProtectedRoute>
                }
              />

              <Route
                path="events/:id"
                element={
                  <ProtectedRoute roles={['ADMIN', 'OFFICER', 'VOLUNTEER']}>
                    <EventDetail />
                  </ProtectedRoute>
                }
              />

            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
